module.exports = __webpack_public_path__ + "static/media/new-tiguan.aa19719b.png";